import { useAsync, type AsyncState } from "@/components/useAsync";
import { fetchWorkingComment } from "@/data/interventionsRepository";

/** Loads administrators' working comment for an intervention when `enabled`. */
export function useWorkingComment(
  interventionId: string | undefined,
  enabled: boolean,
): AsyncState<string> {
  const key = enabled && interventionId ? `comment:${interventionId}` : null;
  const [state] = useAsync(key, () => fetchWorkingComment(interventionId!));
  return state;
}
